<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.company-administration.title"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <div class="header-wrapper">
      <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
      @if (selectedClient) {
        <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      }
      @if (selectedClient) {
        <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]='showInactive' cssClass="checkbox-large ms-auto"></ejs-checkbox>
      }
    </div>
  </div>
</div>
@if (selectedClient) {
  <div class="control-section">
    <ejs-grid #grid
              class="grid-with-toolbar grid-with-footer"
              width='100%'
              rowHeight='38'
              [dataSource]='data'
              [allowSorting]='true'
              [filterSettings]='filterSettings'
              [allowFiltering]='true'
              [allowPaging]='true'
              [pageSettings]='pageSettings'
              [editSettings]='editSettings'
              [searchSettings]="searchOptions"
              (actionComplete)="actionComplete($event)"
              (actionBegin)="actionBegin($event)">
      <ng-template #toolbarTemplate let-data>
        <ejs-toolbar>
            <e-items>
              <e-item text="{{ 'i18n.domain.company-administration.add-button-text' | translate }}" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
            </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        <e-column field='id' [visible]='false' headerText='id' [isPrimaryKey]='true'></e-column>
        <e-column field='name'
          headerText="{{'i18n.shared.fields.name' | translate}}"
          clipMode='EllipsisWithTooltip'>
        </e-column>
        <e-column field='active'
                  headerText="{{'i18n.shared.fields.active' | translate}}"
                  width="160px"
                  [visible]='showInactive'
                  [defaultValue]='true'
                  [filter]="isActiveFilter">
          <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'active')}}</ng-template>
          <ng-template #template let-data>
            <span class="e-icons" [class.icon-checkmark]="data.active"></span>
          </ng-template>
        </e-column>
        <e-column headerText="" [commands]='gridCommands' width='120px'></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate let-data>
        <app-company-form [companyForm]="gridEditForm"></app-company-form>
      </ng-template>
    </ejs-grid>
  </div>
}
